import axios from "axios";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Post from "./Screen/Post/Post";

const TestPaginate = () => {
  useEffect(() => {
    fetchData();
  }, []);

  const [posts, setPosts] = useState([]);
  const [paginate, setPaginate] = useState(1);
  const [status, setstatus] = useState(true);

  const fetchData = () => {
    alert("ok");
    axios
      .get(`api/user/all_post/with-paginate/5?page=${paginate}`)
      .then((res) => {
        if (res.data.status === 200) {
          setPosts([...posts, ...res.data.posts]);
          setPaginate(paginate + 1);
          setstatus(false);
        }
      });
  };

  return (
    <>
      <h1 className="text-light text-center">{paginate}</h1>

      <InfiniteScroll
        dataLength={posts.length}
        next={fetchData}
        hasMore={true}
        loader={<h4>Loading...</h4>}
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>Yay! You have seen it all</b>
          </p>
        }
      >
        <Post style={{ height: "30vh" }} posts={posts} status={status} />
      </InfiniteScroll>
    </>
  );
};

export default TestPaginate;
